declare global {
  interface Window {
    CrazyGames: {
      SDK: {
        init: () => Promise<void>;
        ad: {
          requestAd: (type: 'midgame' | 'rewarded') => Promise<void>;
        };
        game: {
          gameplayStart: () => Promise<void>;
          gameplayStop: () => Promise<void>;
        };
      };
    };
  }
}

export const crazyGames = {
  isAvailable: () => {
    const hostname = window.location.hostname.toLowerCase();
    const isCrazyGamesHost = [
      'crazygames.com',
      'crazygames.net',
      '1001juegos.com',
      '1001games.com',
    ].some((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
    return isCrazyGamesHost && Boolean(window.CrazyGames?.SDK?.ad);
  },
  init: async () => {
    if (crazyGames.isAvailable()) {
      try {
        await window.CrazyGames.SDK.init();
        console.log('CrazyGames SDK initialized');
      } catch (e) {
        console.error('CrazyGames init error:', e);
      }
    }
  },
  requestAd: async (type: 'midgame' | 'rewarded'): Promise<boolean> => {
    if (crazyGames.isAvailable()) {
      try {
        await window.CrazyGames.SDK.ad.requestAd(type);
        return true;
      } catch (e) {
        console.error('CrazyGames ad error:', e);
        return false;
      }
    } else {
      console.log('CrazyGames SDK not found');
      return false;
    }
  },
  gameplayStart: async () => {
    if (crazyGames.isAvailable()) {
      try {
        await window.CrazyGames.SDK.game.gameplayStart();
      } catch (e) {
        console.error('CrazyGames gameplayStart error:', e);
      }
    }
  },
  gameplayStop: async () => {
    if (crazyGames.isAvailable()) {
      try {
        await window.CrazyGames.SDK.game.gameplayStop();
      } catch (e) {
        console.error('CrazyGames gameplayStop error:', e);
      }
    }
  }
};
